<template>
  <div>
    <div class="my-5 d-flex align-center">
      <h4>List Activity</h4>
      <v-btn class="ml-4 btn" color="#016443">
        <h4 style="color: white; font-weight: normal" @click="exportData">
          Export Data
        </h4>
      </v-btn>
    </div>
    <!-- <div>
      <v-row no-gutters class="my-2">
        <v-col cols="12" md="10">
          <div class="my-2 d-flex align-center">
            <v-icon class="mr-2"> mdi-text-search </v-icon>
            <v-text-field
              placeholder="Search Event Name"
              solo
              v-model="find"
              @keyup="fetchData"
              hide-details
              dense
              prepend-inner-icon="mdi-magnify"
              flat
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <div class="my-2 ml-3 d-flex justify-end">
            <v-btn
              depressed
              block
              color="#016443"
              @click="fetchData"
              dark
              class="px-6"
            >
              Search
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div> -->
    <v-row align="center">
      <v-col cols="12" md="7">
        <p class="default_txt">Search Activity</p>
        <v-text-field
          placeholder="Search"
          solo
          v-model="find"
          @keyup="fetchData"
          hide-details
          dense
          prepend-inner-icon="mdi-magnify"
          flat
          color="#006341"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="2"> </v-col>
      <v-col cols="12" md="3" v-if="listTsa">
        <p class="default_txt">Select TSA</p>
        <v-select
          dense
          hide-details
          :items="listTsa"
          item-text="name"
          item-value="id"
          v-model="tsa"
          @change="fetchData()"
          placeholder="Filter TSA"
          flat
          solo
        ></v-select>
      </v-col>
    </v-row>
    <div class="mt-5">
      <v-skeleton-loader
        class="my-5"
        type="table-tbody"
        v-if="loading"
      ></v-skeleton-loader>
      <div v-if="dataSet && !loading && dataSet">
        <v-data-table
          :headers="headers"
          :items="dataSet"
          :page.sync="page"
          :items-per-page="limit"
          class="elevation-0 color_txt"
          hide-default-footer
          :single-select="false"
        >
          <template v-slot:[`item.created_at`]="{ item }">
            <div class="d-flex align-center justify-center">
              <h4 style="font-weight: normal">
                {{ $date(item.created_at).format("MMM DD, YYYY") }}
              </h4>
            </div>
          </template>
          <template v-slot:[`item.tsa`]="{ item }">
            <div
              class="d-flex align-center justify-center"
              v-if="item.data_tsa"
            >
              <p class="mb-0">
                {{ item.data_tsa.name }}
              </p>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex align-center justify-center">
              <v-btn class="mr-2" icon @click="viewDetail(item)">
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </div>
      <div class="text-center my-2 pa-3" v-if="dataSet">
        <v-pagination
          v-model="page"
          color="#006341"
          @input="fetchData"
          :length="last_page"
        ></v-pagination>
      </div>
      <div
        class="empty d-flex align-center justify-center flex-column"
        v-if="!dataSet && !loading"
      >
        <img
          src="../../../../../assets/img/redaksi/pagenotfound.png"
          height="250px"
          alt=""
        />
        <b class="default_txt my-3">Data not found</b>
      </div>
    </div>
    <dialog-large
      :d_large="d_large"
      @refetch="fetchData"
      @close="d_large = false"
      :inventory="inventory"
      :type="d_type"
      :title="d_title"
      line="true"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({}),
  },
  name: "listResponseEventMicroTsa",
  components: {},
  data() {
    return {
      d_large: false,
      loading: false,
      hide_title: "",
      btnTitle: "",
      inventory: "",
      d_type: "",
      d_title: "",
      dataSet: [],
      page: 1,
      limit: 10,
      find: "",
      listTsa: [],
      tsa: "",
      headers: [
        {
          text: "TITLE",
          align: "center",
          value: "title",
          sortable: false,
        },
        {
          text: "STATUS",
          align: "center",
          value: "progress",
          sortable: false,
        },
        {
          text: "TYPE",
          align: "center",
          value: "type",
          sortable: false,
        },
        {
          text: "ACTIVITY DATE",
          align: "center",
          value: "event_date",
        },
        {
          text: "TSA",
          align: "center",
          value: "tsa",
        },
        {
          text: "ACTION",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
      form: [
        {
          label: "Title",
          type: "text",
          form: "title",
        },
        {
          label: "Progress",
          type: "select",
          form: "progress",
          opt: ["On Progress", "Done"],
        },
        {
          label: "Type",
          type: "text",
          form: "type",
        },
        {
          label: "Description",
          type: "textarea",
          form: "description",
        },
        {
          label: "Activity Date",
          type: "date",
          form: "event_date",
        },
        {
          label: "Additional Info",
          type: "text",
          form: "additional_info",
        },

        {
          label: "Link Participant",
          type: "text",
          form: "link_pendataan_peserta",
        },
        {
          label: "Link Evaluation",
          type: "text",
          form: "link_evaluasi",
        },
        {
          label: "Link Dokumentasi",
          type: "text",
          form: "link_dokumentasi",
        },
      ],
    };
  },
  mounted() {
    this.fetchData();
    this.getTsa();
  },
  methods: {
    exportData() {
      let data = {
        path: `tsa-mikro/export?filter[title]=${this.find}`,
        body: "",
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          location.href = data.path;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `tsa-mikro?page[number]=${this.page}&page[size]=${this.limit}&filter[title]=${this.find}&filter[tsa_id]=${this.tsa}&include=dataTsa&sort=-created_at`,
      };

      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    getTsa() {
      let data = {
        path: `manage/univ/get`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.listTsa = data.data;
          let reset = {
            id: "",
            name: "All TSA",
          };
          this.listTsa.unshift(reset);
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    viewDetail(item) {
      this.d_title = "View Event";
      this.d_type = "c_eventMicroTsaScholar";
      let body = {
        id: item.id,
        title: item.title,
        progress: item.progress,
        type: item.type,
        description: item.description,
        start_date: item.start_date,
        additional_info: item.additional_info,
        link_pendataan_peserta: item.link_pendataan_peserta,
        link_evaluasi: item.link_evaluasi,
        link_dokumentasi: item.link_dokumentasi,
      };
      this.inventory = {
        body: body,
        form: this.form,
        disable: true,
      };
      this.d_large = true;
      this.hide_title = true;
    },
  },
};
</script>

<style></style>
